import React from "react";
import './../styles/SingularProject.css';
import LongProjectInfo from "./LongProjectInfo";
import ShortProjectInfo from "./ShortProjectInfo";
const SingularProject = function (props) {
    const visualizedTags = visualizeKeywords(props.features.tags.concat(props.features.technologies));
    return React.createElement("div", { className: "fullProject collapsed" },
        React.createElement(ShortProjectInfo, { hasStar: props.features.hasStar, programmingLanguages: props.features.programmingLanguages, title: props.title, description: props.description, image: props.image }),
        React.createElement(LongProjectInfo, { video: props.video },
            visualizedTags,
            React.createElement("br", null),
            props.children));
};
const startingIndex = 100;
function visualizeKeywords(tags) {
    let processedTags = tags.flatMap((tag, index) => [React.createElement("a", { key: startingIndex + index * 2, className: "featureTag" }, tag), React.createElement("a", { key: startingIndex + index * 2 + 1 }, ", ")]);
    if (processedTags.length !== 0)
        processedTags = processedTags.slice(0, -1);
    return processedTags;
}
export default SingularProject;
